// react
// utils
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
// redux
import { useDispatch } from "react-redux";
import { GenerateProcess } from "redux-process";

// components
import Button from "../Button";
import Paginator from "../Pagination";
// style
import css from "./ReviewTemplateModal.module.scss";

export const ModalButton = (props) => {
	const { createReview } = props;
	return (
		<Button size="large" onClick={createReview} color="green">
			Create Review
		</Button>
	);
};

export const ModalContent = (props) => {
	const { handleTemplateInputChange } = props;
	const [reviewTemplates, setReviewTemplates] = useState("");
	const [reviewTemplateCount, setReviewTemplateCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [checkedTemplateID, setCheckedTemplateID] = useState(null); // default template gets set to None

	const dispatch = useDispatch();

	const handleInputChange = (value) => {
		if (value === 0 || value === null) {
			handleTemplateInputChange(null);
		} else {
			handleTemplateInputChange(value);
		}
		setCheckedTemplateID(value);
	};

	// Calls FetchBulkTemplates with page number.
	// Sets the offset number to skip per page number.
	// Sets templates and number of templates in component state
	const loadTemplates = async (page) => {
		const templateResponse = await dispatch(GenerateProcess("FetchBulkTemplates", { offset: (page - 1) * 10 }));
		setReviewTemplates(templateResponse.response.json);
		setReviewTemplateCount(templateResponse.response.count);
	};

	// changing page should also be rendering new set of review templates
	const handlePageChange = async (nextPage) => {
		setCurrentPage(nextPage);
		loadTemplates(nextPage);
	};

	// On mount, load templates on first page
	useEffect(() => {
		loadTemplates(1);
	}, []);

	const ReviewTemplate = () => {
		const reviewTemplateList = reviewTemplates.map((template) => (
			<li key={template.id} className={css.templateRow}>
				<label className={css.rowContent}>
					<input
						className={css.radioButton}
						type="radio"
						checked={template.id === checkedTemplateID}
						onChange={() => handleInputChange(template.id)}
						onClick={() => handleInputChange(template.id)}
					/>
					{template.name}
				</label>
			</li>
		));

		return (
			<ul>
				<li key={0} className={css.templateRow}>
					<label className={css.rowContent}>
						<input
							className={css.radioButton}
							type="radio"
							checked={checkedTemplateID === null}
							onChange={() => handleInputChange(null)}
							onClick={() => handleInputChange(null)}
						/>
						None
					</label>
				</li>
				{reviewTemplateList}
			</ul>
		);
	};

	return (
		<div>
			<h2 className={css.modalHeader}>Which review template would you like to use?</h2>

			{reviewTemplates && reviewTemplateCount > 0 ? (
				<div className={css.modalCreateReviewButton}>
					<ReviewTemplate />
				</div>
			) : null}

			{reviewTemplates && reviewTemplateCount > 10 ? (
				<div className={css.paginatorWrapper}>
					<Paginator
						pageCount={Math.ceil(reviewTemplateCount / 10)}
						currentPage={currentPage}
						onClick={handlePageChange}
					/>
				</div>
			) : null}
		</div>
	);
};

ModalButton.propTypes = {
	createReview: PropTypes.func.isRequired,
};

ModalContent.propTypes = {
	handleTemplateInputChange: PropTypes.func.isRequired,
};
